import React, { useState } from "react";

import { Identity } from "@safetyculture/s12-apis-connect-web/s12/identity/admin/v1/identity_management_pb";

import { IdentityContext } from "./identity-context";

interface IdentityContextWrapperProps {
  children: React.ReactNode;
}

const IdentityContextWrapper = ({ children }: IdentityContextWrapperProps) => {
  const [identity, setIdentity] = useState<Identity>(new Identity());
  const identityContextValue = { identity, setIdentity };

  return (
    <IdentityContext.Provider value={identityContextValue}>
      {children}
    </IdentityContext.Provider>
  );
};

export default IdentityContextWrapper;
